<template>
  <div class="tva-highlight-component tva-row">
    <div class="highlight tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-offset-4 tva-col-md-7">
      <h5>{{content}}</h5>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content"]
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/bootstrap-grid.scss";
.tva-highlight-component {
  .highlight h5 {
    padding-left: 20px;
    margin-left: 20px;
    margin-bottom: 30px;
    margin-top: 30px;
    border-left: solid 2px $eni-yellow;
  }
}
@media (max-width: 1024px) {
  .tva-highlight-component {
    .highlight h5 {
      margin-left: 0px;
    }
  }
}
</style>



